import { Checkbox, ControlLabel, DropdownItem, DropdownText } from 'gu-ui-kit'
import isEqual from 'lodash/isEqual'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ActionButtons from 'components/Filters/ActionButtons'

const CheckboxGroup = ({
  label = '',
  name,
  onApply = () => {},
  onDrop = () => {},
  showActionButtons = true,
  onSelect = () => {},
  value = [],
  options = [],
  defaultValue = [],
  optionsWrapperClassName = '',
  ...rest
}) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(value)

  useEffect(() => !isEqual(checked, value) && setChecked(value), [value])

  useEffect(() => onSelect(checked), [checked])

  const toggle = useCallback(
    (toggledValue) => {
      if (checked.includes(toggledValue)) {
        setChecked(
          checked.filter((checkboxItem) => checkboxItem !== toggledValue),
        )
      } else {
        const newVal = checked.concat(toggledValue)
        setChecked(newVal)
      }
    },
    [checked],
  )

  const applyValue = useCallback(() => onApply(checked), [checked])

  const dropFilter = useCallback(() => {
    setChecked(defaultValue)
    onDrop()
  }, [setChecked])

  return (
    <>
      {label?.length > 0 && <DropdownText>{t(label)}</DropdownText>}
      <div className={optionsWrapperClassName}>
        {options.map((option) => (
          <DropdownItem key={name + '-option-' + option.value}>
            <ControlLabel
              onChange={() => toggle(option.value)}
              checked={checked.includes(option.value)}
              value={option.value}
              name={name}
              control={<Checkbox />}
              label={
                rest?.renderLabel ? rest.renderLabel(option) : t(option.label)
              }
            />
          </DropdownItem>
        ))}
      </div>
      <ActionButtons
        dropFilter={dropFilter}
        applyValue={applyValue}
        showActionButtons={showActionButtons}
      />
    </>
  )
}

CheckboxGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onApply: PropTypes.func,
  showActionButtons: PropTypes.bool,
  onSelect: PropTypes.func,
  value: PropTypes.array,
  defaultValue: PropTypes.any,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.any,
    }),
  ),
  optionsWrapperClassName: PropTypes.string,
  onDrop: PropTypes.func,
}

export default CheckboxGroup
